import React, {useState} from 'react';
import {Button, designSystemToken} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import BriefFieldInput from '@/views/campaigns/brief/components/brief-field-input/BriefFieldInput';
import Modal from '@/components/modal/Modal';
import useAuthenticateShopify from '@/hooks/mutations/use-authenticate-shopify';
import styles from './CreatorPayments.module.scss';
import ShopifyIcon from './ShopifyIcon';

const TRANSLATION_PREFIX =
  'components.campaign-brief.sections.creator-payments.shopify-link-modal';

interface ShopifyLinkModalProps {
  brandId: string;
  isOpen: boolean;
  onClose: () => void;
}

function ShopifyLinkModal({brandId, isOpen, onClose}: ShopifyLinkModalProps) {
  const [shopName, setShopName] = useState('');

  const {mutate: authenticateShopify, isLoading} = useAuthenticateShopify();

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      showCloseButton
      size="small"
      contentClassName={styles.modalContent}
    >
      <div className={styles.modal}>
        <label className={styles.modalTitle}>
          {translate(`${TRANSLATION_PREFIX}.title`)}
        </label>
        <label className={styles.info}>
          {translate(`${TRANSLATION_PREFIX}.info`)}
        </label>
        <BriefFieldInput
          value={shopName}
          className={styles.shopifyStoreNameInput}
          onInputChange={setShopName}
          placeholder={translate(`${TRANSLATION_PREFIX}.placeholder`)}
        />
        <Button
          appearance="neutral"
          disabled={!shopName || isLoading}
          mode="filled"
          size="large"
          style={{marginTop: 16}}
          onClick={() => {
            authenticateShopify({
              shop_name: shopName,
              merchant_id: brandId,
              success_redirect_url: window.location.href,
            });
          }}
          icon={
            <ShopifyIcon
              color={
                !shopName
                  ? 'rgba(163, 166, 172, 0.50)'
                  : designSystemToken('semantic.bg.neutral-inverse')
              }
            />
          }
        >
          {isLoading
            ? translate(`${TRANSLATION_PREFIX}.loading`)
            : translate(`${TRANSLATION_PREFIX}.button`)}
        </Button>
      </div>
    </Modal>
  );
}

export default ShopifyLinkModal;
